import * as Constants from './constants'
export const onScreenDetails= async(code)=>{
    //for account registration
    try {
 
        const resp = await fetch(`${Constants.apiUrl}/profile/screens/${code}`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
          },
        });
        
        const data = await resp.json();
       return data;
       
      } catch (error) {
 
        console.error(error);
        
      }
}
export const onGetStates= async()=>{
            //for account registration
            try {
              
                const resp = await fetch(`${Constants.apiUrl}/profile/states`, { 
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
                const data = await resp.json();
               return data;
              } catch (error) {
                
                console.error(error);   
              }
        }
  export const onGetLgs= async(stateid)=>{
              //for account registration
              try {
                
                  const resp = await fetch(`${Constants.apiUrl}/profile/lgs/${stateid}`, { 
                    method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
                  const data = await resp.json();
                 return data;
                 
                } catch (error) {
                  
                  console.error(error);   
                }
          }
          
export const onGetCities= async(lgid)=>{
              //for account registration
              try {
                  const resp = await fetch(`${Constants.apiUrl}/profile/cities/${lgid}`, { 
                    method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
                  const data = await resp.json();
                 return(data)
                 
                } catch (error) {
                  
                  console.error(error);   
                }
          }      
      export const onVerifyStayOfExecution= async(caseid)=>{
            //for account registration
            try {
              
                const resp = await fetch(`${Constants.apiUrl}/filing/verify-stay-of-execution/${caseid}`, { 
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
                const data = await resp.json();
              if(data.code==0){
                  return data.verified;
                }else{
                  return null;
                }
               
              } catch (error) {
                
                console.error(error);  
                return null; 
              }
        }    
        export const onVerifyAppeal= async(caseid)=>{
            //for account registration
            try {
              
                const resp = await fetch(`${Constants.apiUrl}/filing/verify-appeal-judgement/${caseid}`, { 
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
                const data = await resp.json();
                if(data.code==0){
                  return data.verified;
                }else{
                  return null;
                }
               
              } catch (error) {
                
                console.error(error);  
                return null; 
              }
        }          